(function ($) {
  const placeHint = function (element) {
    if (!element) return;

    const infoLabelIsPresent = $("#main_building_not_shared_info").length;
    const coverAmount = parseInt(element.value, 10);
    const standardCover = 600000;
    if (!infoLabelIsPresent && coverAmount <= standardCover) {
      const div = $(`
        <div id='main_building_not_shared_info'>
          <div id='main_building_not_shared_info_img'></div>
          <div id='main_building_not_shared_info_text'>
            Our buildings insurance covers up to £600,000 as standard.
            This is to provide assurance that your property is covered for this amount,
            regardless of any difficulty you may have in estimating your property's rebuild cost.
          </div>
        </div>
      `);
      $(element.parentElement.parentElement).after(div);
    } else if (infoLabelIsPresent && coverAmount > standardCover) {
      $("#main_building_not_shared_info").remove();
    }
  };

  $("#main_building_not_shared").change(function (event) {
    placeHint(event.target);
  });
  placeHint(document.getElementById("main_building_not_shared"));
})(window.jQuery);
